<template>
  <div class="xxtz_wrap">
    <div class="xxtz_box">
      <div class="xxtz_left">
        <div class="xx_title">
          <el-input
            v-model="searchValue"
            style="width: 180px; height: 24px"
            size="small"
            placeholder="请输入内容"
          >
            <template #append>
              <el-button @click="noticeSearchClick()">搜索</el-button>
            </template>
          </el-input>

          <div class="all_read" @click="noticeRead()">全部已读</div>
        </div>

        <div class="xxtz_list_box">
          <div
            class="xxtz_list"
            v-infinite-scroll="noticeLoad"
            :infinite-scroll-disabled="noticeDisabled"
            :infinite-scroll-immediate="false"
          >
            <div
              class="xxtz_item"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="noticeClick(item, index)"
            >
              <div class="title">{{ item.title }}</div>

              <div class="time">
                <div>{{ item.createTime }}</div>
                <div>{{ item.read === 1 ? "已读" : "未读" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="xxtz_content">
        <div v-if="noticeList.length > 0">
          <div class="title">{{ noticeList[readIndex].title }}</div>

          <div class="time">{{ noticeList[readIndex].createTime }}</div>

          <div class="content">{{ noticeList[readIndex].content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";

export default {
  props: {
    infoList: {},
    userInfo: {},
    noticeSearchValue: "",
  },
  data() {
    return {
      searchValue: this.noticeSearchValue,
      pageNum: 1,
      pageSize: 20,
      noticeDisabled: false,

      readIndex: 0,
      noticeList: [],
    };
  },
  created() {},
  mounted() {
    this.getNoticeList(); // 获取 消息 list
  },
  methods: {
    // 获取 消息 list
    getNoticeList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userNo: this.userInfo.userNo,
        strategyId: this.infoList.id,
        keyword: encodeURIComponent(this.searchValue),
      };

      this.API.CLOUDGet("quant/api/ai-strategy/notice/list", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.rows;
          // console.log(datas);

          if (datas) {
            if (datas.length < this.pageSize) {
              this.noticeDisabled = true;
            }

            this.noticeList = this.noticeList.concat(datas);

            if (this.noticeList.length > 0) {
              if (this.noticeList[0].read != 1) {
                this.noticeRead(this.noticeList[0]); // 消息 已读
              }
            }
          }
        }
      );
    },

    // 滚动加载
    noticeLoad() {
      this.pageNum += 1;
      this.getNoticeList(); // 获取 消息 list
    },

    // 搜索
    noticeSearchClick() {
      if (this.searchValue) {
        this.noticeList = [];

        this.getNoticeList(); // 获取 消息 list
      }
    },

    // 消息 click
    noticeClick(item, index) {
      if (this.readIndex != index) {
        this.readIndex = index;

        if (this.noticeList[index].read != 1) {
          this.noticeRead(item); // 消息 已读
        }
      }
    },

    // 消息 已读
    noticeRead(item) {
      let data = {
        strategyId: this.infoList.id,
        noticeId: item?.id ?? null,
        userNo: this.userInfo.userNo,
        type: item ? 0 : 1,
      };

      this.API.CLOUDPost1("quant/api/ai-strategy/notice/read", data).then(
        (res) => {
          if (res.data.code == 200) {
            if (!item) {
              ElMessage.success("全部已读成功");

              this.noticeList = this.noticeList.map((item) => ({
                ...item,
                read: 1,
              }));
            } else {
              this.noticeList[this.readIndex].read = 1;
            }

            this.$emit("getNoticeNums"); // 调取 父页面 获取消息未读数量
          } else {
            ElMessage.error("已读失败，请重试");
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.xxtz_wrap {
  .xxtz_box {
    margin-top: 36px;
    min-height: 650px;
    border: 5px solid #28324b;
    display: flex;
    justify-content: space-between;

    .xxtz_left {
      width: 310px;
      padding-left: 6px;
      box-sizing: border-box;

      .xx_title {
        padding: 10px 3.73% 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .all_read {
          font-size: 12px;
          cursor: pointer;
        }
      }

      .xxtz_list_box {
        padding-bottom: 14px;

        .xxtz_list {
          height: 600px;
          overflow: auto;
          padding-right: 4px;

          .xxtz_item {
            padding: 14px 3.73%;
            border-top: 5px solid #28324b;
            cursor: pointer;

            &:first-child {
              border-top: 0;
              padding-top: 0;
            }

            &:last-child {
              padding-bottom: 0;
            }

            .title {
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .time {
              font-size: 12px;
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            }
          }

          &::-webkit-scrollbar {
            width: 8px; /* 滚动条宽度 */
          }

          /* 滚动条轨道 */
          &::-webkit-scrollbar-track {
            background: #050a1a; /* 轨道背景颜色 */
            border-radius: 5px; /* 轨道圆角 */
          }

          /* 滚动条滑块 */
          &::-webkit-scrollbar-thumb {
            background: #d8d8d8; /* 滑块颜色 */
            border-radius: 5px; /* 滑块圆角 */
          }

          /* 滚动条滑块悬停状态 */
          &::-webkit-scrollbar-thumb:hover {
            background: #d8d8d8; /* 滑块悬停颜色 */
          }

          /* 滚动条角落 */
          &::-webkit-scrollbar-corner {
            background: #fff; /* 角落背景颜色 */
          }
        }
      }
    }

    .xxtz_content {
      width: calc(100% - 314px);
      border-left: 5px solid #28324b;
      padding: 40px 3.73%;
      box-sizing: border-box;

      .title {
        font-size: 18px;
        font-weight: bold;
      }

      .time {
        font-size: 12px;
        margin: 24px 0;
      }

      .content {
        font-size: 14px;
        font-weight: bold;
        text-align: justify;
      }
    }
  }
}
</style>